import { createContext, useContext, useState, useCallback } from "react"
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogAction,
  AlertDialogCancel,
} from "@/components/ui/alert-dialog"

const ConfirmDialogContext = createContext(null)

export function ConfirmDialogProvider({ children }) {
  const [state, setState] = useState({ open: false })

  const confirm = useCallback(({ title, description, okText = "Confirmar", cancelText = "Cancelar", variant = "default", onOk, onCancel }) => {
    setState({
      open: true,
      title,
      description,
      okText,
      cancelText,
      variant,
      onOk,
      onCancel,
    })
  }, [])

  const handleOk = async () => {
    if (state.onOk) await state.onOk()
    setState({ open: false })
  }

  const handleCancel = () => {
    if (state.onCancel) state.onCancel()
    setState({ open: false })
  }

  return (
    <ConfirmDialogContext.Provider value={confirm}>
      {children}
      <AlertDialog open={state.open} onOpenChange={(open) => !open && handleCancel()}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{state.title}</AlertDialogTitle>
            {state.description && (
              <AlertDialogDescription>{state.description}</AlertDialogDescription>
            )}
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={handleCancel}>{state.cancelText}</AlertDialogCancel>
            <AlertDialogAction
              onClick={handleOk}
              className={state.variant === "danger" ? "bg-red-500 hover:bg-red-600 text-white" : ""}
            >
              {state.okText}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </ConfirmDialogContext.Provider>
  )
}

export function useConfirmDialog() {
  const ctx = useContext(ConfirmDialogContext)
  if (!ctx) throw new Error("useConfirmDialog must be used inside ConfirmDialogProvider")
  return ctx
}
